export enum KeyboardType {
    STANDARD = 0,
    NUMPAD,
    NO_SPECIALS_ALL_CAPS
}


// WEBPACK FOOTER //
// ./src/constants/keyboardTypes.ts